'use strict';
var parent = require('../../stable/object/assign');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/actual/object/assign.js
// module id = 541
// module chunks = 13